import { render, staticRenderFns } from "./FormIssues.vue?vue&type=template&id=35766d08&scoped=true"
import script from "./FormIssues.vue?vue&type=script&lang=js"
export * from "./FormIssues.vue?vue&type=script&lang=js"
import style0 from "./FormIssues.vue?vue&type=style&index=0&id=35766d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35766d08",
  null
  
)

export default component.exports